(function () {
  angular.module('lif.controllers').controller("linkListBlockController", linkListBlockController);
  linkListBlockController.$inject = ['$rootScope', '$scope', 'bootstrappedLinkListBlockModel', 'formService', 'userService', 'constants'];

  function linkListBlockController($rootScope, $scope, bootstrappedLinkListBlockModel, formService, userService, constants) {
    var vm = this;
    vm.adding = false;
    vm.isEditable = bootstrappedLinkListBlockModel.editable;
    vm.links = bootstrappedLinkListBlockModel.links;
    vm.groupPage = bootstrappedLinkListBlockModel.groupPage;
    vm.currentBlockTitle = bootstrappedLinkListBlockModel.currentBlockTitle;

    vm.addLink = function () {
      if (!vm.title || !vm.url) return false;
      var title = vm.title;
      var url = vm.url;
      vm.adding = true;
      formService.addLink(vm.currentBlockTitle, vm.groupPage, title, url).then(function (link) {
        vm.links.unshift({
          Id: link.Id,
          Url: link.Url,
          Title: link.Title,
          Date: link.Date,
          EventId: link.EventId
        });
        var groupEvent = {
          Date: link.Date,
          Message: "Lade till " + link.Title + " till " + vm.currentBlockTitle,
          User: userService.getLoggedInUser().name,
          Id: link.EventId,
          GroupEventType: constants.GroupEventType.Link
        };
        $rootScope.$broadcast('groupEvent', groupEvent);
        vm.title = "";
        vm.url = "";
        vm.adding = false;
        $scope.showAddLink = false;
      }, function () {
        vm.adding = false;
        $scope.showAddLink = false;
      });
    };

    vm.showRemoveLinkModal = function (link) {
      vm.linkToRemove = link;
      $("#removeLinkItemModal").modal("show");
    };

    vm.removeLink = function (link) {
      var index;
      vm.links.forEach(function (item, i) {
        if (item === link) {
          index = i;
        }
      });
      link.removing = true;
      formService.removeLink(vm.currentBlockTitle, vm.groupPage, link.Id).then(function (eventId) {
        vm.links.splice(index, 1);
        var groupEvent = {
          Date: link.Date,
          Message: "Tog bort " + link.Title + " från " + vm.currentBlockTitle,
          User: userService.getLoggedInUser().name,
          Id: eventId,
          GroupEventType: constants.GroupEventType.Link
        };
        $rootScope.$broadcast('groupEvent', groupEvent);
        link.removing = false;
        $("#removeLinkItemModal").modal("hide");
      }, function () {
        link.removing = false;
        $("#removeLinkItemModal").modal("hide");
      });
    };
  }

  ;
})();